<template>
  <div class="prompt-wrap">
    <div v-if="insTypeList" class="risk-box">
      <dl class="risk">
        <dt class="hd">
          <i>风险提示</i>
        </dt>
        <dd class="bd">
          <p
            v-for="(item, index) in insTypeList"
            :key="index"
          >
            {{ item }}
          </p>
        </dd>
      </dl>
    </div>
    <div class="reminder" />
  </div>
</template>

<script>
  import { insTypeOrders } from 'base/config'
  import riskContent from './riskContent'

  export default {
    props: {
      typeList: {
        type: [Array, Object],
        default() {
          return []
        }
      },
      categorySort: {
        type: String,
        default: 'normal'
      },
      sortList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      insTypeList() {
        const { sortList, typeList, categorySort } = this
        const insTypeOrder = Array.isArray(sortList) && sortList.length > 0 ? sortList : insTypeOrders[categorySort || 'normal']
        return riskContent(typeList, insTypeOrder)
      }
    }
  }
</script>

<style lang="postcss">
  @import 'variable.css';
  .prompt-wrap {
    position: relative;
    @apply --widthcenter;
    color: var(--patch-color-text);
    font-size: 0.26rem;
  }
  .risk-box {
    @apply --box;
    padding: 0.3rem;
    color: var(--primary-color-text);
    .hd {
      font-size: 0.34rem;
      font-weight: bold;
      margin-bottom: 0.16rem;
      text-align: center;
    }
    .bd {
      font-size: 0.32rem;
      padding-left: 0.3rem;
    }
    p {
      position: relative;
      line-height: 1.5;
      margin-bottom: 9px;
      &::before {
        content: '';
        position: absolute;
        left: -15px;
        top: 7px;
        font-size: 20px;
        line-height: 1;
        vertical-align: middle;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: var(--theme-primary-color);
      }
    }
  }
</style>